import $ from 'jquery'

function mergeShippingRow() {
    var $table = $('.woocommerce-checkout-review-order-table');

    // repère la ligne "Expédition" (ou Shipping / Livraison)
    var $titleRow = $table.find('tfoot tr').filter(function () {
        return $(this).find('th[colspan="2"]').text().match(/Expédition|Shipping|Livraison/i);
    });

    if (!$titleRow.length) return;

    var $shippingRow = $titleRow.next('.woocommerce-shipping-totals.shipping');
    if (!$shippingRow.length) return;

    // Cherche le label de la méthode cochée ou unique
    var $label = $shippingRow.find('input.shipping_method:checked + label, .woocommerce-shipping-methods label').first();

    if (!$label.length) return;

    // Texte de la méthode (sans le prix) + prix séparé
    var methodName = $label.clone();              // clone pour manipuler
    var priceHtml  = methodName.find('.woocommerce-Price-amount').detach(); // détache le prix
    var methodText = methodName.text().replace(':', '');            // retire le ":"
    var priceText  = priceHtml.length ? priceHtml.prop('outerHTML') : '';

    // Fusionne en une seule ligne
    var label = $titleRow.find('th').text().trim();
    var newRow = '<tr class="shipping"><th>' + label + '</th><td>'
        + priceText + ' <small>via ' + methodText + '</small></td></tr>';

    $titleRow.replaceWith(newRow);
    $shippingRow.remove();
}

// Exécute au chargement initial
mergeShippingRow();
// Et après chaque rafraîchissement AJAX du checkout
$(document.body).on('updated_checkout', mergeShippingRow);

// Au chargement initial
mergeShippingRow();

// Après chaque mise à jour AJAX du checkout
$(document.body).on('updated_checkout', mergeShippingRow);